import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useState } from 'react';
import useDebounce$1 from './useDebounce.js';

/**
 * A hook that returns a modified version of useState where the setter function is debounced
 * @param {*} initialState The initial state value
 * @param {number} wait Debounce time in milliseconds
 * @returns {[]} An array containing the state value and a debounced function to update it
 */

var useDebouncedState = function useDebouncedState(initialState, wait) {
  var _useState = useState(initialState),
      _useState2 = _slicedToArray(_useState, 2),
      debounced = _useState2[0],
      setDebounced = _useState2[1];

  var update = useDebounce$1(setDebounced, wait);
  return [debounced, update];
};

var useDebouncedState$1 = useDebouncedState;

export { useDebouncedState$1 as default };
